import { useQueries } from 'react-query';
import { getInfoAttachData } from '../requests/getInfoAttachData';

export const createInfoPreviewKey = ({ infoId, fileName }) => [
  'infoPreview',
  infoId,
  fileName,
];

const useInfoPreviews = ({ rawImages, infoId, options = {} }) => {
  const queries = rawImages.map((image) => {
    const { fileName } = image;
    return {
      queryKey: createInfoPreviewKey({ infoId, fileName }),
      queryFn: () => getInfoAttachData(infoId, fileName),
      options: {
        staleTime: Infinity,
        enabled: Boolean(infoId && fileName),
        ...options,
      },
    };
  });

  return useQueries(queries);
};

export default useInfoPreviews;
